<script setup lang="ts">
import NavItem from "@/components/Layout/Landing/HeaderNavItemLanding.vue";

interface NavItem {
  path?: string;
  hash?: string;
  title?: string;
  icon?: string;
}
interface Props {
  items?: NavItem[];
}

const props = defineProps<Props>();
const emit = defineEmits(["on-click"]);
</script>

<template>
  <div class="flex items-center">
    <nav>
      <ul class="flex sm:items-center gap-[14px] flex-col sm:flex-row">
        <NavItem
          v-for="(item, index) in props.items"
          :key="index"
          :item="item"
          @click="emit('on-click')"
        />
      </ul>
    </nav>
  </div>
</template>
